import type { Theme } from '@mui/material';

export const styles = {
  muiTreeItemRoot: (theme: Theme) => ({
    '.MuiTreeItem-content': {
      padding: 0,
      marginBottom: 1,

      [theme.breakpoints.down('md')]: {
        alignItems: 'flex-start',
      },

      '&:hover, &.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
        backgroundColor: `transparent`,
      },

      '.MuiTreeItem-iconContainer': {
        [theme.breakpoints.down('md')]: {
          paddingTop: 3,
        },
      },
    },
  }),

  stackedBar: {
    flexGrow: 1,
    display: 'flex',
  },

  stackElement: (
    count: number,
    highestCount: number,
    isRootLevel = true,
    color: string,
  ) => ({
    textAlign: 'center',
    fontSize: 14,
    lineHeight: isRootLevel ? 28 : 20,
    width: `${Math.round((count / highestCount) * 100)}%`,
    height: isRootLevel ? 28 : 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: color,
  }),

  relevanceIcon: {
    position: 'relative',
  },

  relevanceIconFiller: (percent: number) => ({
    position: 'absolute',
    left: 0,
    top: 0,
    svg: {
      clipPath: `inset(${(1 - percent) * 100}% 0 0 0)`,
    },
  }),

  medalRelevanceIcon: (theme: Theme) => ({
    content: '" "',
    display: 'inline-block',
    top: '0.05rem',
    right: '0.25rem',
    position: 'relative',
    backgroundColor: theme.colors.secondary[500],
    borderRadius: '50%',
    maxHeight: '1rem',
    maxWidth: '1rem',
    minHeight: '1rem',
    minWidth: '1rem',
    '&:hover': { cursor: 'default !important' },
  }),

  relevanceIconGap: (theme: Theme) => ({
    position: 'relative',
    '&:hover': { cursor: 'default !important' },

    [theme.breakpoints.down('lg')]: {
      padding: '0.5rem',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
  }),
};
